import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, model, input, output, effect, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { IPagination } from "app/core/http";
import { PaginationService } from "./pagination.service";

@Component({
  selector: 'pagination-list',
  templateUrl: './pagination-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule

  ],
})
export class PaginationListComponent {
  private readonly _paginationService = inject(PaginationService);
  pagination =  this._paginationService.pagination;

  paginationChanged = output<IPagination>();
 
  isLoading = model<boolean>(false);

  pageSize = input<number>(25);

  pageChanged = model<number>(this.pageSize());

  totalPages = model<number>(1);
  

  changePage(page: number) {
    if (page > 0 && page <= this.pagination().totalPages) {
      let pagination = this.pagination();
      pagination.currentPage = page;
      this._paginationService.setPagination(pagination);
      this.paginationChanged.emit(this.pagination());
    }
  }

  getDisplayedPages() {
    const pages = [];
    const totalPages = Math.max(1, this.pagination().totalPages);
    for (let i = 1; i <= this.pagination().totalPages; i++) {
      if (i === 1 || i === this.pagination().totalPages || (i >= this.pagination().currentPage - 2 && i <= this.pagination().currentPage + 2)) {
        pages.push(i);
      } else if (i === this.pagination().currentPage - 3 || i === this.pagination().currentPage + 3) {
        pages.push('...');
      }
    }
    return pages;
  }

  get totalCount() {
    return this.pagination().totalCount;
  }

  trackByPage(index: number, page: number | string): number | string {
    return page;
}
}